import type React from 'react';
import { memo } from 'react';

import cn from 'classnames';

import { isEmptySessionNow } from '@shared/helpers';

import * as st from './styles.module.scss';

interface Props
	extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
	start: Date;
	end: Date;
}

export const EmptyEditorSession: React.FC<Props> = memo(({ start, end, ...props }) => {
	const isNow = isEmptySessionNow({ start, end });
	return <div className={cn(st.emptySession, isNow && st.now)} {...props} />;
});
